/**
 * Typed client-side env accessor.
 * Vite exposes anything prefixed `VITE_` on `import.meta.env`.
 * This module centralises the access so test mocks can stub one function.
 */

interface ClientEnv {
  GHOST_URL: string;
  GHOST_CONTENT_API_KEY: string;
  YOUTUBE_API_KEY: string;
  YOUTUBE_CHANNEL_HANDLE: string;
}

export function getClientEnv(): ClientEnv {
  const env = import.meta.env as Record<string, string | undefined>;
  return {
    GHOST_URL: env['VITE_GHOST_URL'] ?? '',
    GHOST_CONTENT_API_KEY: env['VITE_GHOST_CONTENT_API_KEY'] ?? '',
    YOUTUBE_API_KEY: env['VITE_YOUTUBE_API_KEY'] ?? '',
    YOUTUBE_CHANNEL_HANDLE: env['VITE_YOUTUBE_CHANNEL_HANDLE'] ?? '',
  };
}

/** True if a value is a non-empty string. */
export function isConfigured(value: string | undefined | null): value is string {
  return typeof value === 'string' && value.length > 0;
}
